import { Search } from "lucide-react";

export const ShowroomSearch = ({
  copy,
  query,
  searchMatches,
  setQuery,
  onSubmit,
  onSelectBrand,
  onSelectModel,
}) => {
  const hasMatches = (
    searchMatches.brandGroups.length > 0 ||
    searchMatches.modelSuggestions.length > 0
  );

  return (
    <div className="relative z-20 isolate flex justify-end">
      <form
        onSubmit={onSubmit}
        className="relative z-20 flex h-12 w-full border border-white/35 bg-black/20 sm:w-[340px]"
      >
        <Search size={19} className="ml-4 shrink-0 self-center text-slate-300" />
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          data-testid="showroom-search-input"
          placeholder={copy.search}
          autoComplete="off"
          className="min-w-0 flex-1 bg-transparent px-3 text-sm text-white outline-none placeholder:text-slate-400"
        />
        {hasMatches && (
          <div
            data-testid="showroom-search-suggestions"
            className="pointer-events-auto absolute left-0 right-0 top-[calc(100%+8px)] z-30 max-h-[19rem] overflow-y-auto border border-white/20 bg-[#0a0f10]/95 p-1 shadow-2xl backdrop-blur"
          >
            {searchMatches.brandGroups.map(({ brand, models }) => (
              <div key={brand} className="border-b border-white/10 py-1 last:border-b-0">
                <button
                  type="button"
                  onClick={() => onSelectBrand(brand)}
                  data-testid={`showroom-search-all-brand-${brand}`}
                  className="block w-full bg-white/[0.07] px-4 py-3 text-left transition-colors hover:bg-[#89d3cb]/20"
                >
                  <span className="block text-sm font-bold text-white">
                    {copy.allBrandModels.replace("{brand}", brand)}
                  </span>
                </button>
                {models.map((model) => (
                  <button
                    key={`${brand}-${model}`}
                    type="button"
                    onClick={() => onSelectModel(brand, model)}
                    data-testid={`showroom-search-model-${brand}-${model}`}
                    className="block w-full px-4 py-3 text-left transition-colors hover:bg-white/10"
                  >
                    <span className="block truncate text-sm font-semibold text-white">
                      {model}
                    </span>
                    <span className="mt-0.5 block text-xs uppercase tracking-[0.15em] text-[#99ddd4]">
                      {brand}
                    </span>
                  </button>
                ))}
              </div>
            ))}
            {searchMatches.modelSuggestions.map(({ brand, model }) => (
              <button
                key={`${brand}-${model}`}
                type="button"
                onClick={() => onSelectModel(brand, model)}
                data-testid={`showroom-search-model-${brand}-${model}`}
                className="block w-full px-4 py-3 text-left transition-colors hover:bg-white/10"
              >
                <span className="block truncate text-sm font-semibold text-white">{model}</span>
                <span className="mt-0.5 block text-xs uppercase tracking-[0.15em] text-[#99ddd4]">
                  {brand}
                </span>
              </button>
            ))}
          </div>
        )}
      </form>
    </div>
  );
};